import { FesNotification } from '../../../../../brokers/fes-notification.model';
import { CommerceProviderError } from './commerce-provider.titles';

export const commerceProviderTenantsError = (): FesNotification =>
  new FesNotification(CommerceProviderError.tenants);

export const commerceProviderStoresError = (): FesNotification =>
  new FesNotification(CommerceProviderError.stores);
